import React from 'react'
import { H3 } from '../Heading/index'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'

/**
 * The What's included promo component
 * @param {Object} props - The props
 * @param {Map} props.staticText - The static text
 * @param {Function} props.onJoinButtonClick - The join gaia button event handler
 * @returns {JSX.Element} The included promo component
 */

function GaiaPlusIncluded (props) {
  const {
    staticText,
    onJoinButtonClick,
  } = props

  return (
    <div className="gaia-plus-page__included">
      <div className="gaia-plus-page__included-container">
        <H3>{staticText.get('includedTitle')}</H3>
        <div className="gaia-plus-page__included-section gaia-plus-page__included-section--top">
            <H3>{staticText.get('workshopsEvents')}</H3>
            <p className="gaia-plus-page__included-section-text">
              {staticText.get('workshopsEventsText')}
            </p>
        </div>
        <div className="gaia-plus-page__included-section gaia-plus-page__included-section--bottom">
            <H3>{staticText.get('guidedPrograms')}</H3>
            <p className="gaia-plus-page__included-section-text">
              {staticText.get('guidedProgramsText')}
            </p>
        </div>
        <Button
          type={BUTTON_TYPES.PRIMARY}
          className="gaia-plus-page__included-button"
          onClick={onJoinButtonClick}
        >
          {staticText.get('joinGaiaPlusNow')}
        </Button>
      </div>
    </div>
  )
}

export default GaiaPlusIncluded
